export default {
  projects: "Events",
  add_project: "+ Add Event",
  account: "Account",
  profile: "Profile",
  subscription: "Subscription",
  logOut: "Logout",
};



// WEBPACK FOOTER //
// ./src/views/user/components/navigation/Navigation.messages.js